export default __webpack_public_path__ + "static/media/linkedin.abb498c3.png";